import { render, staticRenderFns } from "./FaturaCancelada.vue?vue&type=template&id=32ac9c8d&scoped=true"
import script from "./FaturaCancelada.vue?vue&type=script&lang=js"
export * from "./FaturaCancelada.vue?vue&type=script&lang=js"
import style0 from "./FaturaCancelada.vue?vue&type=style&index=0&id=32ac9c8d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ac9c8d",
  null
  
)

export default component.exports